var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{class:{active: _vm.index === _vm.currentContentBlockType},on:{"click":_vm.setContentBlockType}},[_c('img',{attrs:{"src":_vm.getCardIcon}}),_c('p',[_vm._v(_vm._s(_vm.contentBlockType.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }